module.exports = __webpack_public_path__ + "img/Tutoriales.a31db499.jpg";